import { Autocomplete, Backdrop, CircularProgress, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { getOrgChartUser, getUserDetailsWithEmail, getUsers } from "../../services/user.service"
import { useDispatch } from "react-redux";
import { setUserState } from "../../store/userSlice";
import { toast } from "react-toastify";
import { EMAIL_SUFFIX } from "../../services/const";
import { checkAndUpdateUserToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";


const User = () => {

	const [selectedUser, setSelectedUser] = useState<any>()
	const [userList, setUserList] = useState<any[]>([])
	const [isDropDownLoading,setIsDropDownLoading] = useState<boolean>(false)
	const [fullScreenLoading, setFullScreenLoading] = useState(false);
	const [searchValue, setSearchValue] = useState<string>("");
	
	const dispatch = useDispatch();
	const navigate = useNavigate();
		
	const getUserList = async(email: string) =>{
		const isUserTokenValid = await checkAndUpdateUserToken();
		if (!isUserTokenValid) {
				sessionStorage.clear();
				navigate("/notFound");
				return;
		}
		let userListData = [];
		const openProjectDetails: any = JSON.parse(localStorage.getItem('openProjectLoginDetails') || '{}');
    	const jiraDetails: any = JSON.parse(localStorage.getItem('jiraLoginDetails') || '{}');
		const chartId = sessionStorage.getItem("chartId") || "";
		const userId = sessionStorage.getItem("userId") || '';

		let loginUser: any = {};
		try {
			setIsDropDownLoading(true)
			setFullScreenLoading(true)

			const userDetails = await getOrgChartUser(chartId, email, userId);
			if(userDetails && userDetails.data) {
				userListData = userDetails.data.subEmployeesDetails;
				delete userDetails.data.subEmployeesDetails;
				userListData.push(userDetails.data)
				loginUser = userDetails.data;
			}
		} catch (error) {
			userListData = []
		} finally {
			setIsDropDownLoading(false)
			setFullScreenLoading(false)
		}
		setSelectedUser(loginUser);
		setSearchValue(loginUser?.name || "");
		dispatch(setUserState({ userDetails:loginUser, jiraDetails: jiraDetails.userDetails, openProjectDetails: openProjectDetails.userDetails }))
		
		setUserList(userListData);
		const userNameReport = userListData.map((e: any) => {
			return {
				user: e.email_address.split('@')[0],
				userName: e?.name + " " +e?.surName,
				userEmail: e.email_address
			}
		});
		sessionStorage.setItem('userNameReport', JSON.stringify(userNameReport))
	}

	const getOrgUserList = async() =>{
		let userListData = [];
		const email = new Set();
		const openProjectDetails: any = JSON.parse(localStorage.getItem('openProjectLoginDetails') || '{}');
    	const jiraDetails: any = JSON.parse(localStorage.getItem('jiraLoginDetails') || '{}');
		try {
			setIsDropDownLoading(true);
			setFullScreenLoading(true);
			if(jiraDetails && Object.keys(jiraDetails).length) {
				email.add(jiraDetails?.userDetails?.emailAddress);
			} else if(openProjectDetails && Object.keys(openProjectDetails).length) {				
				email.add(`${openProjectDetails?.userDetails?.login}${EMAIL_SUFFIX.WAYMORE}`)
				.add(`${openProjectDetails?.userDetails?.login}${EMAIL_SUFFIX.AMDTELECOM}`);
			}

			const response = await getUsers(email);
			userListData = response?.data || [];
		} catch (error) {
			userListData = [];
		} finally {
			setIsDropDownLoading(false);
			setFullScreenLoading(false);
		}

		const mappedEmail = Array.from(email).map((e_mail: any) => e_mail.toLowerCase());
		const loginUser = userListData?.find((user:any) => mappedEmail.includes(user?.email_address?.toLowerCase()));
		setSelectedUser(loginUser);
		setSearchValue(loginUser?.name || "");
		dispatch(setUserState({ userDetails:loginUser, jiraDetails: jiraDetails.userDetails, openProjectDetails: openProjectDetails.userDetails }))
		setUserList(userListData)
	}

	const getUserDetail = async(email:string) =>{
		let userDetailResponse
		try {
			setFullScreenLoading(true)
			userDetailResponse = await getUserDetailsWithEmail(email)
			const jiraDetails = userDetailResponse?.data?.jiraDetails[0]
			const openProjectDetails = userDetailResponse?.data?.openProjectDetails[0]
			return {jiraDetails,openProjectDetails}
		} catch (error) {
			userDetailResponse = {}
		}finally {
			setFullScreenLoading(false)
		}
	}


	const handleBlur = () => {
		setSearchValue(selectedUser?.name || "");
  };

	const handleSearch = async (value:any,reason:any) =>{
    if( ["input","clear"].includes(reason)) {
			setSearchValue(value || "");
    }
  }

	const handleSelectUser = async(value: any) => {
		if(value){
			const user = userList?.find(user => user?.id == value?.id);
			const userDetails = await getUserDetail(user?.email_address);
			if(userDetails?.jiraDetails || userDetails?.openProjectDetails ){
				dispatch(setUserState({userDetails:user,jiraDetails:userDetails?.jiraDetails,openProjectDetails:userDetails?.openProjectDetails }))
				setSelectedUser(value);
				setSearchValue(value?.name);
			}else {
				toast.warn('User Details Missing');
				setSearchValue(selectedUser?.name || "");
			}
		}
  };


	useEffect(()=>{
		const user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user") || '') : {};

		if(user.email_address) {
		 	getUserList(user.email_address);
		} else {
			// getOrgUserList();
		}
	},[])	

  return (
    <div>
			<Backdrop open={fullScreenLoading} sx={{zIndex:(theme)=> theme.zIndex.drawer +1}}>
				<CircularProgress />
			</Backdrop>
			{userList?.length > 1 ?
				<Autocomplete
					autoFocus={false}
					value={selectedUser}
					options={userList}
					loading={isDropDownLoading}
					loadingText="Loading..."
					isOptionEqualToValue={(option, value) => option?.id === selectedUser?.id}
					onInputChange={(_,value,reason)=>handleSearch(value,reason)}
					getOptionLabel={(option) => `${option?.name} ${option?.surName || ''}`}
					onChange={(_,value) => handleSelectUser(value)}
					onBlur={handleBlur}				
					ListboxProps={{style:{maxHeight:250}}}
					inputValue={
						selectedUser ? `${selectedUser.name} ${selectedUser.surName || ''}` : searchValue
					  } 
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										{isDropDownLoading ? <CircularProgress color="inherit" size={20} /> : null}
										{params.InputProps.endAdornment}
									</>
								),
							}}
						/>
					)}
				/>
				: 
				selectedUser?.name && <span className="user-dropdown-login-user-name">{`${selectedUser.name}${selectedUser.surName ? ` ${selectedUser.surName}` : ''}`}</span> 
			}
    </div>
  )
}

export default User;
